// Question 6 upsetting events: the field each one is stored in, and how the form words it.
export const SCREENER_EVENTS = [
  { field: 'eventFamilyBreakdown', label: 'Family breakdown' },
  { field: 'eventSexualIdentityConflict', label: 'Conflict relating to sexual identity' },
  { field: 'eventChildCustody', label: 'Child custody issues' },
  { field: 'eventRelationshipProblem', label: 'Relationship problem' },
  { field: 'eventLossOfLovedOne', label: 'Loss of loved one' },
  { field: 'eventChronicPainOrIllness', label: 'Chronic pain/illness' },
  { field: 'eventTrauma', label: 'Trauma' },
  { field: 'eventImpendingLegalProsecution', label: 'Impending legal prosecution' },
] as const;

export const SCREENER_PRESENTATIONS = [
  { field: 'presentsAgitated', label: 'Agitated' },
  { field: 'presentsConfused', label: 'Disorientated/confused' },
  { field: 'presentsDelusional', label: 'Delusional/hallucinating' },
] as const;

// The risk levels a screener can end on (RISK_RATING lookup codes), the wording the form uses for them, and the
// response it suggests for each.
export const SCREENER_RISK_LEVELS = [
  {
    code: 'LOW_RISK',
    label: 'Low',
    indicators: ['No plans or intent', 'No prior attempt/s', 'Few risk factors', 'Identifiable protective factors'],
    response: [
      'Monitor and review risk frequently',
      'Identify potential supports/contacts and provide contact details',
      'Consult with a colleague or supervisor for guidance and support',
      'Refer client to safety plan and keep safe strategies should they start to feel suicidal',
    ],
  },
  {
    code: 'MEDIUM_RISK',
    label: 'Moderate',
    indicators: [
      'Suicidal thoughts of limited frequency, intensity and duration',
      'No plans or intent',
      'Some risk factors present',
      'Some protective factors',
    ],
    response: [
      'Request permission to organise a specialist mental health service assessment as soon as possible',
      'Refer client to safety plan and keep safe strategies as above',
      'Consult with a colleague or supervisor for guidance and support',
      'Remove means where possible',
      'Review daily',
    ],
  },
  {
    code: 'HIGH_RISK',
    label: 'High',
    indicators: [
      'Frequent, intense, enduring suicidal thoughts',
      'Clear intent, specific/well thought out plans',
      'Prior attempt/s',
      'Many risk factors',
      'Few/no protective factors (or highly changeable)',
    ],
    response: [
      'If the client has an immediate intention to act, contact the mental health crisis team immediately and ensure that the client is not left alone',
      'Remove means where possible',
      'Call an ambulance/police if the client will not accept a specialist assessment, or the crisis team is not available',
      'Consult with a colleague or supervisor for guidance and support',
    ],
  },
] as const;

// The rule on the form: expressing thoughts of suicide while presenting as agitated, confused or delusional is High.
export function isAutomaticallyHigh(thoughtsOfSuicide: boolean | null, presentations: boolean[]): boolean {
  return thoughtsOfSuicide === true && presentations.some(Boolean);
}
